import styled from 'styled-components';
import Disclaimer from '../../_shared/components/Disclaimer';

export const StyledVhrDisclaimer = styled.div`
  font-size: 14px;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  margin: -6px 0 18px;
  text-align: center;
  padding: 0 18px;
`;

export const AutoWinDisclaimer = styled(Disclaimer)`
  margin: 20px 18px 0;
`;
